module.exports = require('./src/wordCloud');


//////////////////
// WEBPACK FOOTER
// ./~/echarts-wordcloud/index.js
// module id = 178
// module chunks = 0